import Responsive from './Responsive';
import Swiper from 'swiper';

module.exports = function() {
	const r = new Responsive();

	const wrapper = $('.home_slide_wrapper');
	const target = '#js-home_slide';
	let slide_obj = undefined;
	let slide_num = $(target).find('li').length;

	let slide_options = {
		speed:800,
		slidesPerView: 'auto',
		spaceBetween: 10,
		loop:true,
		nextButton: '.swiper-button-next-home_slide',
		prevButton: '.swiper-button-prev-home_slide',
		pagination: '.swiper-pagination-home_slide',
		paginationClickable: true,
		centeredSlides:true,
		autoplay:5000
	};

	const top_slide = ()=>{
		if( $(window).width()> 768){
			if(slide_num == 1 || slide_num == 2){
				wrapper.addClass('js-slide-oh_hidden');
				$('.home_slide-ctrl').hide();
				if(slide_num == 2){
					$('.home_slide').css('width','1200px');
				}
				return false;
			}
		}else{
				$('.home_slide').css('width','');
		}
		slide_obj = new Swiper(target,slide_options);
	}

	top_slide();
	$(window).on('resize',function(){
		top_slide();
	});

}



// WEBPACK FOOTER //
// ./dev/js/scripts/slide_home.js